import { Button, Grid } from "@material-ui/core";
import React from "react";

import eye from "assets/icon/vuesax-outline-eye.svg";
import charge from "assets/icon/vuesax-outline-lamp-charge.svg";
import redJudge from "assets/image/ideation/red_judge.svg";
import redLump from "assets/image/ideation/lamp_charge_red.svg";

import heart from "assets/icon/vuesax-bold-heart.svg";
import Apis from "constants/Api";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { ideaMentoring } from "screens/Ideation/actions";
import menuBoardBlue from "assets/image/ideation/menu_board_blue.svg";

const useStyles = makeStyles((theme) => ({
  ideaCardContainer: {
    backgroundColor: "#fff",
    borderRadius: 25,
    userSelect: "none",
    position: "relative",
    overflow: "hidden",
    transition: "all 0.2s linear",
    "&:hover": {
      boxShadow: "0 12px 20px 5px rgb(0 0 0 / 34%)",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 340,
    },
  },
  ideaCardImageContainer: {
    userSelect: "none",
  },
  viewBtn: {
    backgroundColor: "#EB633E",
    border: "2px solid #fff",
    color: "#fff",
    borderRadius: "30px",
    "&:hover": {
      backgroundColor: "#c74623",
    },
  },
  acceptBtn: {
    backgroundColor: "#CB1C68",
    border: "2px solid #fff",
    color: "#fff",
    borderRadius: "30px",
    "&:hover": {
      backgroundColor: "#a21854",
    },
  },
}));

export default function ActivityCard({ item, currentUserSlug }) {
  const classes = useStyles();
  const convocationDetail = useSelector(
    (state) => state?.ideation?.convocationDetail
  );
  const dispatch = useDispatch();

  const handleMentoringIdea = () => {
    dispatch(
      ideaMentoring({
        id: item?.id,
        action: currentUserSlug !== item?.mentor ? "take" : "drop",
      })
    );
  };
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className={classes.ideaCardContainer}
      style={{
        border: "1px solid",
        borderColor: item?.score
          ? "#24C1A8"
          : item.mentor
          ? "#EF9825"
          : "#427FF0",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Grid
        container
        alignItems="center"
        direction="column"
        wrap="nowrap"
        style={{
          fontWeight: "bold",
          marginBottom: 10,
          backgroundColor: item?.score
            ? "#24C1A8"
            : item.mentor
            ? "#EF9825"
            : "#427FF0",
          padding: "15px 0",
        }}
      >
        <div
          className="activities_my_boom_activity_title"
          style={{
            textAlign: "center",
            fontSize: 17,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            width: 232,
            overflow: "hidden",
            marginBottom: 24,
            color: "#fff",
          }}
        >
          {item?.title}
        </div>
        <div
          className="activities_my_boom_activity_title"
          style={{
            fontSize: 17,
            color: "#fff",
            marginBottom: 30,
          }}
        >
          {item?.score ? "ثبت نهایی" : item.mentor ? "چکش کاری" : "ثبت ایده"}
        </div>
        <div
          className="activities_my_boom_activity_title"
          style={{
            fontSize: 17,
            backgroundColor: "#fff",
            borderRadius: "100%",
            width: 65,
            height: 65,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "28%",
            boxShadow: "0px 4px 10px rgba(30, 30, 30, 0.25)",
            border: "2px solid",
            borderColor: item?.score
              ? "#24C1A8"
              : item.mentor
              ? "#EF9825"
              : "#2451A4",
          }}
        >
          {item?.score ? (
            <img src={redLump} alt="final" style={{ width: 45 }} />
          ) : item.mentor ? (
            <img src={redJudge} alt="final" style={{ width: 45 }} />
          ) : (
            <img src={redLump} alt="final" style={{ width: 45 }} />
          )}
        </div>
      </Grid>
      <Grid
        container
        style={{
          padding: "10px 10px 0 10px",
          marginTop: 25,
        }}
      >
        <Grid
          container
          style={{
            lineHeight: "1.2em",
            height: "3.6em",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3,
          }}
        >
          {item?.description}
        </Grid>
      </Grid>
      <Grid container style={{ padding: "10px", gap: 10, marginTop: 10 }}>
        <Button
          variant="contained"
          className={classes.viewBtn}
          style={{ flex: 1 }}
          component={Link}
          to={{ pathname: `/ideation/idea/${item?.id}` }}
        >
          مشاهده
        </Button>
        {convocationDetail?.i_am_mentor_in_this_convocation && !item?.mentor ? (
          <Button
            onClick={handleMentoringIdea}
            variant="contained"
            className={classes.acceptBtn}
            style={{ flex: 1 }}
          >
            انتخاب
          </Button>
        ) : currentUserSlug === item?.mentor ? (
          <Button
            onClick={handleMentoringIdea}
            variant="contained"
            className={classes.acceptBtn}
            style={{ flex: 1 }}
          >
            رهاکردن
          </Button>
        ) : null}
      </Grid>
      <Grid
        container
        justify="space-between"
        style={{
          padding: "10px 15px",
        }}
      >
        <Grid
          item
          style={{ display: "flex", alignItems: "center", gap: 10 }}
          className="activities_my_boom_activity_view_count"
        >
          <Grid
            item
            style={{ display: "flex", alignItems: "center" }}
            className="activities_my_boom_activity_view_count"
          >
            <img src={eye} alt="eye" style={{ marginLeft: 5, width: 15 }} />
            <span style={{ fontSize: 14 }}>{item?.view_count}</span>
          </Grid>

          <Grid
            item
            style={{ display: "flex", alignItems: "center" }}
            className="activities_my_boom_activity_like_count"
          >
            <img src={heart} alt="heart" style={{ marginLeft: 5, width: 15 }} />
            <span style={{ fontSize: 14 }}>{item?.like_count}</span>
          </Grid>
        </Grid>
        <Grid
          item
          style={{ display: "flex", alignItems: "center" }}
          className="activities_my_boom_activity_like_count"
        >
          <img src={menuBoardBlue} alt="menuBoardBlue" style={{ width: 18 }} />
          <span style={{ fontSize: 14 }}>{item?.create_time}</span>
        </Grid>
      </Grid>
    </Grid>
  );
}
